
import React, { createContext, useState, useContext } from 'react';

export const WishlistContext = createContext();

export function WishlistProvider({ children }) {
    const [wishlistItems, setWishlistItems] = useState([]);

    const addToWishlist = (product) => {
        setWishlistItems(prevItems => {
            if (prevItems.some(item => item._id === product._id)) {
                return prevItems;
            }
            return [...prevItems, product];
        });
    };

    const removeFromWishlist = (productId) => {
        setWishlistItems(prevItems =>
            prevItems.filter(item => item._id !== productId)
        );
    };

    const isInWishlist = (productId) => {
        return wishlistItems.some(item => item._id === productId);
    };


    return (
        <WishlistContext.Provider value={{
             wishlistItems,
             addToWishlist,
             removeFromWishlist,
             isInWishlist
             }}>
            {children}
        </WishlistContext.Provider>
    );
}

export function useWishlist() {
    return useContext(WishlistContext);
}